const _ = require('lodash')
const moment = require('moment-timezone')
const numeral = require('numeral')

const DATE_FORMAT = 'MMM D Y'
const TIME_FORMAT = 'hh:mma'

function formatCurrency (amount, currencyPrefix = '', customFormat = null) {
  const parsedAmount = ((amount + '').indexOf('.') === -1) ? _.round((numeral(amount).value() / 100), 2) : numeral(amount).value()
  return (currencyPrefix ? currencyPrefix + ' ' : '') + numeral(parsedAmount).format(customFormat || '0,0.00')
}

function convertToDecimalFormat (amount) {
  return ((amount + '').indexOf('.') === -1) ? _.round((numeral(amount).value() / 100), 2) : numeral(amount).value()
}

function formatDate (date, timezone, { displayTimezone = false } = {}) {
  const momentDate = moment.isMoment(date) ? date : (timezone ? moment(date).tz(timezone) : moment(date))
  return momentDate.format(DATE_FORMAT + (displayTimezone ? ' z' : ''))
}

function formatTime (time, timezone, { displayTimezone = false } = {}) {
  let momentDate

  if (moment.isMoment(time)) {
    if (timezone) {
      momentDate = time.tz(timezone)
    } else {
      momentDate = time
    }
  } else if (typeof time === 'string' && /^[0-9]{1,2}:[0-9]{2}$/u.test(time)) {
    // Time provided as "HH:mm" (e.g. "08:00") – let moment parse that as a time
    // and turn it into a Date, optionally in the provided timezone.
    if (timezone) {
      momentDate = moment.tz(time, 'HH:mm', timezone)
    } else {
      momentDate = moment(time, 'HH:mm')
    }
  } else {
    momentDate = timezone ? moment(time).tz(timezone) : moment(time)
  }

  return momentDate.format(TIME_FORMAT + (displayTimezone ? ' z' : ''))
}

function sleep (msecs) {
  return new Promise((resolve) => setTimeout(() => resolve(), msecs))
}

function getShortTransactionLogId (transactionLogId) {
  return transactionLogId.substring(transactionLogId.length - 7).toUpperCase()
}

function getPhonePrefixByCountryId (countryId) {
  switch (countryId) {
    case 'GHA':
      return '+233'
  }
}

function isPhoneNumberValid (phoneNumber) {
  // Clean out common phone number separators
  const cleanedNumber = String(phoneNumber || '').replace(/[()\-\s]+/g, '')

  if (!cleanedNumber) {
    return false
  }

  // Ghana numbers are matched strictly so malformed Ghana inputs (e.g. an extra
  // digit) cannot leak through the looser "other international" rule below.
  // Callers are expected to normalize local-format numbers (e.g. 0XXXXXXXXX) to
  // the international form (+233XXXXXXXXX or 233XXXXXXXXX) before validating.
  if (/^\+?233/.test(cleanedNumber)) {
    return /^\+?233\d{9}$/.test(cleanedNumber)
  }

  // US/Canada number: +1 followed by exactly 10 digits
  if (cleanedNumber.match(/^\+1\d{10}$/)) {
    return true
  }

  // UK number: +44 followed by exactly 10 digits
  if (cleanedNumber.match(/^\+44\d{10}$/)) {
    return true
  }

  // Other international numbers: + followed by 10 to 15 digits (E.164 max is 15)
  if (cleanedNumber.match(/^\+\d{10,15}$/)) {
    return true
  }

  return false
}

/**
 * Convenience function to return the valid support contacts based on phone country code
 * @param {string} phoneCountryCode - e.g. '+233'
 * @returns {{type:('email'|'whatsapp'), value: string}[]}
 */
function getSupportContacts (phoneCountryCode) {
  switch (phoneCountryCode) {
    case '+233':
      return [
        { type: 'email', value: 'support@smarttransyt.com' },
        { type: 'whatsapp', value: '053 102 2770 / +233 53 102 2770' },
        { type: 'phone', value: '053 102 2770 / +233 53 102 2770' }
      ]
    case '+1':
    case '+44':
    default:
      return [
        { type: 'email', value: 'support@smarttransyt.com' },
        { type: 'whatsapp', value: '053 102 2770 / +233 53 102 2770' }
      ]
  }
}

const { getTimezoneByAgencyId } = require('./agency-timezones')

module.exports = {
  formatCurrency,
  convertToDecimalFormat,
  formatDate,
  formatTime,
  getPhonePrefixByCountryId,
  sleep,
  getShortTransactionLogId,
  getSupportContacts,
  isPhoneNumberValid,
  getTimezoneByAgencyId
}
